/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DistributeHorizontalCenterIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Distribute Horizontal Center',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M13 6h-3V.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V6H5a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h3v5.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V30h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1ZM31 10h-3V.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V10h-3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3v9.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V26h3a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1Z"
    />
  </svg>`;
};
